export class Constants {
    public static readonly TOKEN = 'TOKEN';
    public static readonly REFRESH_TOKEN = 'REFRESH_TOKEN';
    public static readonly USER = 'USER';

    public static readonly IOS_PWA_INSTALL_MODAL = 'IOS_PWA_INSTALL_MODAL';

    public static readonly FILTER_LIMIT = 10;
}
